import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { PaymentMethod, PaymentMethodFilters, PaymentMethodDataForm } from '../../models/PaymentMethod';

const usePaymentMethodService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetPaymentMethods, setFetchingGetPaymentMethods] = useState(false);
    const [fetchingStorePaymentMethod, setFetchingStorePaymentMethod] = useState(false);
    const [fetchingEditPaymentMethod, setFetchingEditPaymentMethod] = useState(false);
    const [fetchingUpdatePaymentMethod, setFetchingUpdatePaymentMethod] = useState(false);
    const [fetchingDeletePaymentMethod, setFetchingDeletePaymentMethod] = useState(false);
    const [fetchingActivePaymentMethod, setFetchingActivePaymentMethod] = useState(false);

    const getPaymentMethods = (filters: PaymentMethodFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([, value]) => value !== undefined && value !== '' && value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.PAYMENT_METHODS.GET_PAYMENT_METHODS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetPaymentMethods
        });
    };

    const storePaymentMethod = (paymentMethod: PaymentMethodDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.PAYMENT_METHODS.STORE_PAYMENT_METHOD,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: paymentMethod,
            setFetching: setFetchingStorePaymentMethod
        });
    };

    const editPaymentMethod = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.PAYMENT_METHODS.EDIT_PAYMENT_METHOD.replace(':id', id.toString()),
            setFetching: setFetchingEditPaymentMethod
        });
    };

    const updatePaymentMethod = (id: number, paymentMethod: PaymentMethodDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.PAYMENT_METHODS.UPDATE_PAYMENT_METHOD.replace(':id', id.toString()),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: paymentMethod,
            setFetching: setFetchingUpdatePaymentMethod
        });
    };

    const deletePaymentMethod = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.PAYMENT_METHODS.DELETE_PAYMENT_METHOD.replace(':id', id.toString()),
            setFetching: setFetchingDeletePaymentMethod
        });
    };

    const activePaymentMethod = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.PAYMENT_METHODS.ACTIVE_PAYMENT_METHOD.replace(':id', id.toString()),
            body: { active: active },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingActivePaymentMethod
        });
    };

    return {
        fetchingGetPaymentMethods,
        fetchingStorePaymentMethod,
        fetchingEditPaymentMethod,
        fetchingUpdatePaymentMethod,
        fetchingDeletePaymentMethod,
        fetchingActivePaymentMethod,
        getPaymentMethods,
        storePaymentMethod,
        editPaymentMethod,
        updatePaymentMethod,
        deletePaymentMethod,
        activePaymentMethod
    };
};

export default usePaymentMethodService;
